import Vue from 'vue'
import Router from 'vue-router'
import store from '../../store'
import ExecutiveSummary from "../../views/ExecutiveSummary";
import LoginPage from '@/views/LoginPage.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.VUE_APP_BASE_URL_OVERRIDE&&process.env.VUE_APP_BASE_URL_OVERRIDE!=="" ? process.env.VUE_APP_BASE_URL_OVERRIDE : process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: ExecutiveSummary
    },
    {
      path: '/overview',
      name: 'overview',
      component: ExecutiveSummary
    },{
      path: '/executive-summary',
      name: 'executive-summary',
      component: ExecutiveSummary
    },
    {
      path: '/login',
      name: 'login',
      component: LoginPage,
      meta: { public: true }
    }
  ]
})

router.beforeEach((to, from, next) => {


  if (to.matched.some(r => r.meta.guest) && store.state.userStore.user) {
    next({ name: 'home' })
    return
  }
  next()
})

export default router
